import { isFinite } from 'lodash'

export const round = (num: number, fractionDigits = 0): number => {
  return Math.round(num * Math.pow(10, fractionDigits)) / Math.pow(10, fractionDigits)
}

/**
 * Rounds a number representing a price according to whether it is in cents or not.
 *
 * @param {number} num - The number representing the price.
 * @param {boolean} [isCent=false] - Indicates if the number is in cents. If true, it will be rounded to the nearest whole number. If false or undefined, it will be rounded to two decimal places.
 *
 * @example
 * // Rounding a number in cents
 * const priceInCents = sanitizePrice(123.456, true);  // returns 123
 *
 * @example
 * // Rounding a number in main currency units
 * const priceInDollars = sanitizePrice(123.456);  // returns 123.46
 *
 * @example
 * // Handling non-finite numbers
 * const infinitePrice = sanitizePrice(Infinity);  // returns Infinity
 */

export const sanitizePrice = (num: number, isCent?: boolean): number => {
  if (!isFinite(num)) return num

  if (isCent) {
    return round(num)
  } else {
    return round(num, 2)
  }
}

export const getKiloValue = (num: number): number => {
  return round(num / 1000, 1)
}

export const getValueByType = ({
  value,
  isPercentage = false
}: {
  value?: number
  isPercentage?: boolean
}): number | string => {
  if (value) {
    if (isPercentage) {
      return value
    } else {
      return sanitizePrice(value / 100)
    }
  }

  return ''
}

export const gcd = (a: number, b: number): number => {
  if (b === 0) return a
  return gcd(b, a % b)
}
